export type LanguageCode = string;

export interface Language {
  code: string;
  label: string;
  native_name: string;
  flag: string;
  dir: "ltr" | "rtl";
}

export interface StoreLanguageConfig {
  default: string;
  selected?: string;
  available: Language[];
}

// Default languages (fallback if store API not available)
export const DEFAULT_LANGUAGES: Language[] = [
  {
    code: "en",
    label: "English",
    native_name: "English",
    flag: "🇺🇸",
    dir: "ltr",
  },
];

// RTL language codes
export const RTL_LANGUAGES = ["ar", "he", "fa", "ur"];

export const getDirection = (code: string): "ltr" | "rtl" => {
  return RTL_LANGUAGES.includes(code) ? "rtl" : "ltr";
};

// Multi-language value is now a dynamic Record
export type MultiLangValue = Record<string, string>;

export const createEmptyMultiLang = (
  languages: Language[],
  defaultLang: string,
  defaultValue = "",
): MultiLangValue => {
  const result: MultiLangValue = {};
  languages.forEach((lang) => {
    result[lang.code] = lang.code === defaultLang ? defaultValue : "";
  });
  return result;
};

export interface CollectionItem {
  id: string | number;
  name: string;
  image?: string;
  handle?: string;
}

export interface SectionData {
  id: string;
  name: string;
  collectionTitle: MultiLangValue;
  buttonText: MultiLangValue;
  redirectCollection: string;
  collections: CollectionItem[];
}
// --------------------------------------------
// Normalize API value → MultiLangValue
// --------------------------------------------
export const normalizeMultiLangValue = (
  value: any,
  languages: Language[],
  defaultLang: string,
): MultiLangValue => {
  // Already MultiLang (object)
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value as MultiLangValue;
  }

  // API string → MultiLang
  if (typeof value === "string") {
    const result: MultiLangValue = {};
    languages.forEach((lang) => {
      result[lang.code] = lang.code === defaultLang ? value : "";
    });
    return result;
  }

  // Empty fallback
  return createEmptyMultiLang(languages, defaultLang);
};